
import { ProductList } from "./product"
export function ProductDetails(){
    return(
        <div className="container-fluid">
            <h3>Popular Products</h3>
         <div className="row">
          
          <div className="col-12 col-sm-12 col-lg-3">
             <ProductList
              Image="1stcart/product/product-img-1 (1).jpg"
              title="Snack & Munchies"
              productName="Haldiram's Sev Bhujia"
              star="bi bi-star-half text-warning me-2"
              rate="4.5 (149)"
              newprice="$18"
              oldprice="$24"
             
             />
          </div>
          <div className="col-12 col-sm-12 col-lg-3 ">
             <ProductList
              Image="1stcart/product/product-img-2 (1).jpg"
              title="Snack & Munchies"
              productName="Haldiram's Sev Bhujia"
              star="bi bi-star-half text-warning me-2"
              rate="4.5 (149)"
              newprice="$18"
              oldprice="$24"
             />
          </div>
          <div className="col-12 col-sm-12 col-lg-3">
             <ProductList
              Image="1stcart/product/product-img-3 (1).jpg"
              title="Snack & Munchies"
              productName="Haldiram's Sev Bhujia"
              star="bi bi-star-half text-warning me-2"
              rate="4.5 (149)"
              newprice="$18"
              oldprice="$24"
             />
          </div>
          <div className="col-12 col-sm-12 col-lg-3 ">
             <ProductList
              Image="1stcart/product/product-img-4 (1).jpg"
              title="Snack & Munchies"
              productName="Haldiram's Sev Bhujia"
              star="bi bi-star-half text-warning me-2"
              rate="4.5 (149)"
              newprice="$18"
              oldprice="$24"
             />
          </div>
          <div className="col-12 col-sm-12 col-lg-3 ">
             <ProductList
              Image="1stcart/product/product-img-5 (1).jpg"
              title="Snack & Munchies"
              productName="Haldiram's Sev Bhujia"
              star="bi bi-star-half text-warning me-2"
              rate="4.5 (149)"
              newprice="$18"
              oldprice="$24"
             />
          </div>
          <div className="col-12 col-sm-12 col-lg-3 ">
             <ProductList
              Image="1stcart/product/product-img-6 (1).jpg"
              title="Snack & Munchies"
              productName="Haldiram's Sev Bhujia"
              star="bi bi-star-half text-warning me-2"
              rate="4.5 (149)"
              newprice="$18"
              oldprice="$24"
             />
          </div>
          <div className="col-12 col-sm-12 col-lg-3 ">
             <ProductList
              Image="1stcart/product/product-img-7 (1).jpg"
              title="Snack & Munchies"
              productName="Haldiram's Sev Bhujia"
              star="bi bi-star-half text-warning me-2"
              rate="4.5 (149)"
              newprice="$18"
              oldprice="$24"
             />
          </div>
          <div className="col-12 col-sm-12 col-lg-3 ">
             <ProductList
              Image="1stcart/product/product-img-8 (1).jpg"
              title="Snack & Munchies"
              productName="Haldiram's Sev Bhujia"
              star="bi bi-star-half text-warning me-2"
              rate="4.5 (149)"
              newprice="$18"
              oldprice="$24"
             />
          </div>
         </div>
         


        </div>
    )
}